exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9394ff76] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-9394ff76] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-9394ff76] .el-dialog__body {\n  padding-bottom: 5px;\n}\n", ""]);

// exports
